import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import StorefrontTitle from "../shared/storefront-title.component";
import SorryBanner from "../../assets/img/SadToSeeYouGo.png";
import SpinnerTimeLoader from "../shared/timeLoading";
import storefront from "../../services/storefront.service";
import STF_CONSTANTS from "../../services/stfConstant.service";
import User from "../../services/user.service";
import Storage from "../../services/storage.service";
import Helpers from "../../helpers/shared.helper";
import CONSTANTS from "../../services/constants.service";
import PlanCardSingleAuto from "../storefront/planTab/plan-card-single-auto.component";
import SimDeactivationService from "../../services/sim-deactivation.service";
import ModalWrapperMid from "../shared/modal-wrapper-mid";
import PromptIcon from "../../assets/img/PromptConfirm.svg";
import FirebaseAnalytics from "../../services/analytics.service";

const SimDeactivationPlansSuggestion = props => {

  const [planSuggestions, setPlanSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const getFormData = Storage.get("simDeactivationData", true);
    if(getFormData) {
      setFormData(JSON.parse(getFormData))
    }
  }, [])

  const getPostpaidPlanSuggestions = () => {
    Storage.clear("genericAPIError")
    Storage.get("genericAPIError", true, true);
    Storage.set("is_web_category_selected", true, true);
    Storage.set("choose_sim_deactivation", true, true);
    setLoading(true);
    storefront.fetchPostpaidPlanSuggestions()
      .then((response) => {
        if (response) {
          // Fetch Postpaid Plan Suggestions
          setLoading(false);
          let data = response.data;
          if (data?.Cards?.length) {
            let sortedPlanSuggestionList = storefront.sortData(
              data?.Cards,
              "Order"
            );
            setPlanSuggestions(sortedPlanSuggestionList);
          }
        }
        setLoading(false);
        Storage.clear("genericAPIError")
      })
      .catch((error) => {
        setLoading(false);
        Storage.clear("genericAPIError")
      });
  };

  const checkCardType = (list, index) => {
    let content = "";
    if (list?.Shape === STF_CONSTANTS.HORIZONTAL_CARD) {
      // DO Nothing Only Vertical Cards to be Shown
    } else if (list?.Shape === STF_CONSTANTS.VERTICAL_CARD) {
      if (list?.CardList?.length) {
        list.CardList.forEach((ele) => {
          if (ele?.Type?.length) {
            switch (ele?.Type) {
              case STF_CONSTANTS.PREDEFINED_TYPE:
                content = (
                  <PlanCardSingleAuto
                    key={index}
                    planDetails={ele}
                    setLoading={setLoading}
                    simDeactivationPostpaid={true}
                  />
                );
                break;
              default:
                content = "";
                break;
            }
          }
        });
      }
    }

    return content;
  };

  const handlePostpaidRedirection = (e) => {
    Storage.clear("genericAPIError")
    Storage.get("genericAPIError", true, true)
    handleModal(e);
    setSubmitLoading(true);
    let countryCode = Helpers.getCountryCodePO() || ""; 
    let phoneNumber = formData?.phone
    phoneNumber = `${countryCode}${phoneNumber?.replace(/^0+/, '')}`;    
    const data = {
      number: phoneNumber,
      reason: formData?.reason
    }
    SimDeactivationService.postPaidLineSuspend(data)
      .then((response) => {
        Storage.clear("genericAPIError");
        const formValues = {
          phone: formData.phone,
          idNumber: formData.idNumber,
          idType: formData.idType,
          contact: formData.contact,
          IBAN: formData.IBAN,
          reason: formData.reason
        }
        props.history.push({
          pathname: '/sim-deactivation/bill-summary',
          state: { formValues: formValues }
        });
        if(formData?.reason) {
          let firebase_param = {
            reason_id: formData.reason
          }
          FirebaseAnalytics.closing_pay_bill(firebase_param)
        }
        setSubmitLoading(false);
      })
      .catch(() => {
        setSubmitLoading(false);
        Storage.clear("genericAPIError");
      })
  }

  const handleModal = (e) => {
    e.stopPropagation();
    setOpenModal((prev) => !prev);
  };

  const handleProductCode = (type) => {
    setLoading(true);
    Storage.clear("user_selection");
    Storage.set("is_web_category_selected", true, true);
    Storage.set("choose_plan_category", true, true);
    Storage.clear("choose_sim_deactivation");
    Storage.clear("postpaid_sim_deactivation");
    Storage.clear("simDeactivationData");
    Storage.set("is_custom_card_selected", false, true);
    const checkForProductDetail = Helpers.checkForProductDetail("name", type);
    if(checkForProductDetail?.code) {
      Storage.set("pre-defined-plan-selected-product-code", checkForProductDetail?.code, true);
    }
    User.fetchFlowStatus();
  }

  useEffect(() => {
    getPostpaidPlanSuggestions();
  }, [])

  let content = (
    <>
    <div className="stf-deactivation-cntnr">
      <img src={SorryBanner} alt=""/>
      <StorefrontTitle
        title={Translations.keys["stm_sim_deactivation_sad_see_you_go"]}
        desc={[
            Translations.keys["stm_sim_deactivation_explore_offer"],
            <br />,
            Translations.keys["stm_sim_deactivation_perhaps_continue_service"]
        ]}
      />
      {loading ? <SpinnerTimeLoader /> :
      <>
        <div className="sim-deavtivation-plan-suggestion-header">
            <div>
                <div>{Translations.keys["stm_sim_deactivation_need_more_data"]}</div>
                <span>{Translations.keys["stm_sim_deactivation_check_latest_offers"]}</span>
            </div>
            <div onClick={() => handleProductCode(CONSTANTS.REGULAR_POSTPAID_PRODUCT_ATTR)}>
                {Translations.keys["stm_sim_deactivation_view_all"]}
            </div>
        </div>
        <div className="sim-deactivation-plan-card-container">
          {planSuggestions?.length ? 
          <>
            {planSuggestions?.map((planDetails, index) =>
              <React.Fragment key={"cards" + index}>
                {checkCardType(planDetails, index)}
              </React.Fragment>
            )}
          </> :
          ""
          }
        </div>
        <button className={"common-button"} onClick={handleModal}>{Translations.keys["stm_sim_deactivation_proceed_termination"]}</button>
      </>}
    </div>
    {openModal &&
      <ModalWrapperMid handleToggleModal={handleModal}>
        <div className="progress-prompt-modal">
            <img src={PromptIcon} alt="" />
            <span>{Translations.keys["stm_sim_deactivation_confirm_termination"]}</span>
            <p>{Translations.keys["stm_sim_deactivation_confirm_termination_desc"]}</p>
            <div>
                <button className={"common-button-light"} onClick={handleModal}>{Translations.keys["stf_cancel"]}</button>
                <button className={"common-button"} onClick={handlePostpaidRedirection}>{Translations.keys["stf_confirm"]}</button>
            </div>
        </div>
      </ModalWrapperMid>
    }
    </>

  );
  if (submitLoading) {
    content = <SpinnerTimeLoader />
  }
  return content;
};
export default SimDeactivationPlansSuggestion;
